import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default [
    {
      exact: true,
      path: '/home/polymerize/identity',
      owner: '/home',
      authority: 'identityThemeList',
      component: Loadable({
        loader: () => import('./index'),
        loading: () => <RouteLoading />
      })      
    },
    {
      exact: true,
      path: '/home/polymerize/identity/:id/edit',
      owner: '/home',
      authority: 'identityThemeList',
      component: Loadable({
        loader: () => import('../components/edit'),
        loading: () => <RouteLoading />
      })      
    }

  ];